import React, { useMemo } from "react";
import { getImageUrlHelper } from "../../helper/helper";
import { getAvatarGradient, getInitials } from "../../utils/avatarHelper";

const Avatar = ({
    name = "",
    image,
    size = 40,
    uniqueKey,
}) => {
    const imageUrl = getImageUrlHelper(image);

    const hasImage = !!imageUrl;

    const bgGradient = useMemo(() => {
        return getAvatarGradient(uniqueKey || name);
    }, [uniqueKey, name]);

    const initials = getInitials(name);

    if (hasImage) {
        return (
            <img
                src={imageUrl}
                alt={name}
                style={{ width: size, height: size }}
                className="rounded-circle object-fit-cover"
            />
        );
    }

    return (
        <div
            title={name}
            style={{
                width: size,
                height: size,
                background: bgGradient,
                fontSize: size / 2.5,
            }}
            className="rounded-circle d-flex align-items-center justify-content-center text-white fw-semibold"
        >
            {initials}
        </div>
    );
};

export default Avatar;